import axios from "axios";
import { API_BASE_URL } from "./config";
import { clearSession, markSessionExpired, getAuthToken } from "../utils/storage";

const PUBLIC_PATHS = [
  "/staff/login-staff",
  "/staff/forgot-password",
  "/staff/confirm-delete-account/",
];

/** GET routes that also send a JSON body. */
const GET_BODY_PATHS = [
  "/get-singlefamilymem",
  "/mycart",
  "/diagnosticslots",
  "/singlestafftestpackages",
  "/doctor-slots",
  "/getdoctorappointment",
  "/getPrescription",
  "/getappoint",
  "/single-booking",
  "/getalldiagbookings",
  "/download-report",
  "/getchat",
];

const isPublicRequest = (url = "") =>
  PUBLIC_PATHS.some((path) => String(url).includes(path));

const allowsGetBody = (url = "") =>
  GET_BODY_PATHS.some((path) => String(url).includes(path));

const stripStaffId = (data) => {
  if (!data || typeof data !== "object" || data instanceof FormData) return data;
  if (!Object.prototype.hasOwnProperty.call(data, "staffId")) return data;
  const next = { ...data };
  delete next.staffId;
  return next;
};

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  const url = config.url || "";

  if (token && !isPublicRequest(url)) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const method = (config.method || "get").toLowerCase();

  if (config.data instanceof FormData) {
    if (config.data.has("staffId")) config.data.delete("staffId");
    if (config.headers && typeof config.headers.delete === "function") {
      config.headers.delete("Content-Type");
    } else if (config.headers) {
      delete config.headers["Content-Type"];
    }
  } else if (method === "get") {
    if (!allowsGetBody(url)) {
      delete config.data;
    } else {
      const body = stripStaffId(config.data);
      config.data = body && typeof body === "object" ? body : {};
    }
  } else {
    config.data = stripStaffId(config.data);
  }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    if ((status === 401 || status === 403) && !isPublicRequest(url)) {
      clearSession();
      markSessionExpired();
      window.location.assign("/?reason=session");
    }
    return Promise.reject(err);
  }
);

export default api;
